import axios from 'axios'
import authHeader from '../security/auth.header'

const API_URL = process.env.VUE_APP_BASE_API_URL + '/api/v1/admin/services'

class ServiceApi {
  getList(page, size, sort) {
    const url = new URL(API_URL) // Use URL object for easier parameter management

    url.searchParams.set('actualPage', page)
    url.searchParams.set('perPage', size)

    if (sort && sort.length > 0) {
      sort.forEach(item => {
        url.searchParams.set(`sort[${item.field}]`, item.dir)
      })
    }

    return axios.get(url.toString(), {
      headers: authHeader()
    })
  }

  sortOrder(uuid, data) {
    return axios.put(API_URL + '/' + uuid + '/_sort-order', data, { headers: authHeader() })
  }

  getDetail(uuid) {
    return axios.get(API_URL + '/' + uuid, { headers: authHeader() })
  }

  createService(data) {
    return axios.post(API_URL, data, { headers: authHeader() })
  }

  editService(uuid, data) {
    return axios.put(API_URL + '/' + uuid, data, { headers: authHeader() })
  }

  getPriceAttributeList() {
    return axios.get(API_URL + '/price/attributes', { headers: authHeader() })
  }
}

export default new ServiceApi()
